import type {FondsDataService} from '../../fonds/services/fonds.data-service';
import type {Fond} from 'typings/portaro.be.types';

export class KpRelatedRecordsTablePresenter {
    static presenterName = 'kpRelatedRecordsTablePresenter';

    /*@ngInject*/
    constructor(private fondsDataService: FondsDataService) {
    }

    public async getCompatibleFonds(fondId: number): Promise<Fond[]> {
        return this.fondsDataService.getCompatibleFonds(fondId);
    }
}